module.exports = __webpack_public_path__ + "img/Menu-04.f25eb3c6.png";